import type { IFUserInfo } from "../../../api/apiRsp/IFSigninRsp";

export interface EmIdentity {
  accountId: string | null;
  countryCode: string | null;
  userId: string | null;
  anonymous: boolean;
}

export interface EmUserPropertyContext {
  countryCode?: string | null;
  channel?: string | null;
  pid?: string | null;
}

const normalizeString = (value?: string | number | null): string => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).trim();
};

export const buildEmAccountId = (
  countryCode?: string | null,
  userId?: string | number | null,
): string | null => {
  const normalizedCountryCode = normalizeString(countryCode).toLowerCase();
  const normalizedUserId = normalizeString(userId);

  if (!normalizedCountryCode || !normalizedUserId) {
    return null;
  }

  return `${normalizedCountryCode}:${normalizedUserId}`;
};

export const buildEmIdentity = (
  countryCode?: string | null,
  userId?: string | number | null,
): EmIdentity => {
  const accountId = buildEmAccountId(countryCode, userId);
  const normalizedCountryCode = normalizeString(countryCode).toLowerCase() || null;
  const normalizedUserId = normalizeString(userId) || null;

  return {
    accountId,
    countryCode: normalizedCountryCode,
    userId: normalizedUserId,
    anonymous: !accountId,
  };
};

export const buildEmUserProperties = (
  userInfo?: Partial<IFUserInfo> | null,
  context: EmUserPropertyContext = {},
): Record<string, string | boolean> => {
  const countryCode =
    normalizeString(userInfo?.countryCode || context.countryCode).toLowerCase();
  const channel = normalizeString(context.channel);
  const pid = normalizeString(context.pid);

  return {
    country_code: countryCode,
    channel,
    pid,
    register_country_code: countryCode,
    has_mobile: !!normalizeString(userInfo?.mobile),
    has_email: !!normalizeString(userInfo?.email),
    is_first_recharge: !!userInfo?.isFirstRecharge,
  };
};
